module.exports = __webpack_public_path__ + "img/tiger-bubble.1e985bf1.svg";